import { withPageSuspense } from '@zep/next';
import { compose, withCmsContent, withServerSideTranslations } from '@zep/next/server';
import { PricingProvider } from '../../components/service/subscription';
import { CmsEntries } from '../../consts';
import { PricingPageView } from '../../views';
const PricingPage = () => {
  return <PricingProvider data-sentry-element="PricingProvider" data-sentry-component="PricingPage" data-sentry-source-file="index.tsx">
      <PricingPageView data-sentry-element="PricingPageView" data-sentry-source-file="index.tsx" />
    </PricingProvider>;
};
export const getStaticProps = compose(withServerSideTranslations(['common', 'subscription']), withCmsContent(CmsEntries.PRICING));
export default withPageSuspense(PricingPage);